export default "__VITE_ASSET__ObBYp0Sr__"